import React from "react";
import "../../assets/scss/components/Desincard/index.scss";

function DesignCard(props) {
  // const data = props.titleName;
  // console.log("rpowS", props.titleName,props.name);

  return (
    <React.Fragment>
      <div className={`px-2 CardDesign  ${props.cardClass}`}>
        <div>
          <h4 className="title-bar">
            <span>{props.name}</span>
          </h4>
          {props.name !== "Description" && props.name !== "Rider Note" ? (
            <p className={`des title_name ${props.cardClass}`}>
              {props.titleName}
            </p>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: props.titleName,
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
export default DesignCard;
